import { useNavigate, useSearch } from '@tanstack/react-router';

import { CenteredPagination } from '../../cdl/Pagination/CenteredPagination';
import { Text } from '../../cdl/Text/Text';
import { AdvancedError } from '../../common/Error/AdvancedError';
import { translate } from '../../common/helpers/translate.helper';
import { LoadingIndicator } from '../../common/LoadingIndicator/LoadingIndicator';
import { NoSearchResults } from '../../common/Search/NoSearchResults/NoSearchResults';
import { useOrderPagination } from '../../order/useOrderPagination';

import { SearchResultOrderTable } from './SearchResultOrderTable';

export const CustomerSearchResult = () => {
    const { query, ordersPage } = useSearch({ from: '/_app/search' });
    const navigate = useNavigate({ from: '/search' });

    const paginatedOrdersQuery = useOrderPagination({
        page: ordersPage,
        searchQuery: query,
    });

    if (paginatedOrdersQuery.isPending) {
        return <LoadingIndicator variant="page" />;
    }

    if (paginatedOrdersQuery.isError) {
        return <AdvancedError />;
    }

    if (paginatedOrdersQuery.data.content.length === 0) {
        return (
            <div>
                <Text as="h1" variant="headline" marginBottom={24}>
                    {translate('searchResult.title')}
                </Text>

                <NoSearchResults variant="page" />
            </div>
        );
    }

    return (
        <div>
            <Text as="h1" variant="headline" marginBottom={24}>
                {translate('searchResult.title')}
            </Text>

            <Text as="h2" variant="subtitle1" marginBottom={16}>
                {translate('searchResult.orders')}
            </Text>

            <SearchResultOrderTable orders={paginatedOrdersQuery.data.content} />

            <CenteredPagination
                pageTotal={paginatedOrdersQuery.pageTotal}
                currentPage={ordersPage}
                onPageChange={(page) => navigate({ search: { query, ordersPage: page } })}
            />
        </div>
    );
};
